import { z } from 'zod';
export const CashReceipt = z.object({
    number: z.string(), job_ref: z.string(), quote_id: z.string().nullable(), customer: z.string(), address: z.string(),
    paid_on: z.string(), kind: z.enum(['deposit', 'part', 'balance', 'opening']), amount: z.number(),
    previously_received: z.number(), total_received: z.number(), balance: z.number().nullable(),
    language: z.enum(['en', 'zh']), issuer: z.object({ name: z.string(), address: z.string(), abn: z.string(), phone: z.string(), email: z.string() }),
    note: z.string(), issued_on: z.string(), test: z.boolean().default(false)
});
export const cashCents = (n) => Math.round(Number(n) * 100);
export function cashBalance(total, rows) {
    const paid = rows.filter(r => !r.voided_at).reduce((s, r) => s + cashCents(r.amount), 0);
    const due = total === null || total === undefined ? null : cashCents(total);
    return { received: paid / 100, balance: due === null ? null : (due - paid) / 100 };
}
//# sourceMappingURL=cash-receipt.js.map